var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.$resize.isDesktop)?_c('div',{staticClass:"scroll-to-top",class:{
    'scroll-to-top--show': _vm.show,
  },on:{"click":_vm.clickScrollTop}},[_c('div',{staticClass:"scroll-to-top__row"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }